import React from 'react'
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import Header from './../components/Header';
import Container from '@mui/material/Container';
import Footer from './../components/Footer';
import FooterMenu from './../components/FooterMenu';
import { displayOnDesktop } from 'themes/commonStyles';
import MobileFooter from './../components/MobileFooter';
import OptionsTab from './../components/OptionsTab';
import LocationCards from './../components/LocationCards';

const MainPage = () => {
  return (
<React.Fragment>
<CssBaseline />
<Box
  sx={{
    display: 'flex',
    flexDirection: 'column',
    height: '100vh',
  }}
>
  <Box>
    <Header />
    <OptionsTab />
  </Box>
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flexGrow: 1,
      width:'100%',
      height: 100,
      overflowY: 'scroll'
    }}
  >
    <Container style={{minWidth:'100%'}} sx={{ mb: 0,ml:0,mr:0 }}>
      <LocationCards />
      <Box
        sx={{
          display: { xs: 'flex', md: 'none' },
        }}
      >
        <MobileFooter />
      </Box>
    </Container>
  </Box>
  <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
    <FooterMenu />
  </Box>
  <Box sx={displayOnDesktop}>
    <Footer />
  </Box>
</Box>
</React.Fragment>
    )
}

export default MainPage